<template>
  <loading v-model:active="isLoading" :can-cancel="false" :is-full-page="true" />

  <!-- CADASTRO-->
  <div class="row">
    <div class="col-md-12">
      <div class="card card-primary">
        <div class="card-header">
          <h3 class="card-title" style="color: white">Cadastro de fotos</h3>
        </div>

        <div class="card-body">
          <div class="row">
            <!-- ARQUIVO -->
            <div class="col-sm-12">
              <div class="form-group">
                <label for="exampleInputFile">Arquivo</label>
                <input class="form-control" type="file" @change="onChange" />

                <span style="color: red" v-for="error in v$.upload_files.$errors" :key="error.$uid">
                  {{ error.$message }}
                </span>
              </div>
            </div>

            <!-- DESTAQUE -->
            <div class="col-sm-12">
              <div class="form-group">
                <label for="nome">Destaque</label>

                <select class="custom-select rounded-0" id="endereco_estado" v-model="formData.destaque">
                  <option :value="false">Não</option>
                  <option :value="true">Sim</option>
                </select>

                <span style="color: red" v-for="error in v$.destaque.$errors" :key="error.$uid">
                  {{ error.$message }}
                </span>
              </div>
            </div>
          </div>
        </div>

        <div class="card-footer">
          <button type="submit" class="btn btn-primary" @click="uploadFD()">Cadastrar</button>
          <a type="submit" href="/admin/logos" class="btn btn-danger" style="margin-left: 15px">Voltar</a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import sweetAlert from "../../controller/sweetAlert";
import Swal from "sweetalert2/dist/sweetalert2.js";
import "vue-loading-overlay/dist/vue-loading.css";
import Loading from "vue-loading-overlay";

import useVueLidate from "@vuelidate/core";
import { helpers } from "@vuelidate/validators";
import { required } from "../../locales/i18n.js";
import { computed, reactive } from "vue";

export default {
  mixins: [sweetAlert, Swal],

  props: ["lote"],

  components: { Loading },

  data() {
    return {
      isLoading: false,
    };
  },

  setup() {
    const formData = reactive({
      upload_files: "",
      destaque: "",
    });

    const rules = computed(() => {
      return {
        destaque: { required },
        upload_files: { required },
      };
    });

    const v$ = useVueLidate(rules, formData);

    return { formData, v$ };
  },

  mounted() {},

  methods: {
    onChange(e) {
      this.formData.upload_files = e.target.files[0];
    },

    async uploadFD() {
      const result = await this.v$.$validate();

      if (result) {
        this.isLoading = true;

        let fd = new FormData();
        fd.append("file", this.formData.upload_files);
        fd.append("nome", this.formData.nome);

        console.log("Cadastrando");
        console.log(fd);

        axios
          .post(`/admin/logo/store`, fd)
          .then((response) => {
            this.isLoading = false;

            this.showSuccessMessageWithButtonAndRedirect("Sucesso", "Logo cadastrada", "/admin/logos");
          })
          .catch((error) => {
            this.showErrorMessageWithButton("Ops..", error);
            console.log(error);
          });
      }
    },
  },
};
</script>
